import { SelectInput } from '../../../components/Form/SelectInput';

type InstrumentIssueTypeSelectProps = {
  value: string;
  setValue?: (value: string) => void;
};

const instrumentIssueTypes = [
  { value: 'common-stock', label: 'Common Stock' },
  { value: 'common-stockreit', label: 'Common Stock REIT' },
  { value: 'convertible-common-stock', label: 'Convertible Common Stock' },
  { value: 'exchange-traded-funds', label: 'Exchange Traded Funds' },
  { value: 'ustreasury-bill', label: 'US Treasury Bill' },
  { value: 'ustreasury-note', label: 'US Treasury Note' },
  { value: 'ustreasury-bond', label: 'US Treasury Bond' },
  { value: 'ustreasury-security', label: 'US Treasury Security' },
];

const InstrumentIssueTypeSelect = ({ value, setValue }: InstrumentIssueTypeSelectProps) => {
  return (
    <SelectInput
      label="Issue Type/Subtype"
      enableTopLabel
      value={value ?? ''}
      setValue={setValue}
      values={instrumentIssueTypes.map((type) => ({
        value: type.value,
        display: type.label,
      }))}
    />
  );
};

export default InstrumentIssueTypeSelect;
